// Normalizes a raw price value from an imported CSV/XLS cell.
// Handles both comma and dot as decimal separators, strips thousand separators,
// and returns a JS number regardless of how the source cell was formatted.
const parseImportPrice = (value) => {
	if(typeof value === 'number') return isNaN(value) ? null : value
	if(value === null || value === undefined || value === '') return null

	// Strip currency symbols / letters from the outside in, then any remaining
	// interior non-separator characters.  Doing it in two passes avoids the
	// problem where "Fr. 9.90" leaves a stray leading dot after a naive strip.
	const str = String(value).trim()
		.replace(/^[^\d-]+/, '')   // drop leading non-digit / non-minus  (e.g. "Fr. ", "CHF ", "$")
		.replace(/[^\d]+$/, '')    // drop trailing non-digit             (e.g. " CHF", " €")
		.replace(/[^\d,.-]/g, '')  // drop anything else inside           (e.g. spaces inside)
	if(!str) return null

	const commaCount = (str.match(/,/g) || []).length
	const dotCount = (str.match(/\./g) || []).length
	const lastComma = str.lastIndexOf(',')
	const lastDot = str.lastIndexOf('.')

	let normalized

	if(lastComma !== -1 && lastDot !== -1) {
		// Both separators present — the last one is the decimal separator
		if(lastComma > lastDot) {
			// e.g. "1.234,56" → 1234.56
			normalized = str.replace(/\./g, '').replace(',', '.')
		} else {
			// e.g. "1,234.56" → 1234.56
			normalized = str.replace(/,/g, '')
		}
	} else if(lastComma !== -1) {
		if(commaCount > 1) {
			// Multiple commas → all are thousands separators, e.g. "1,234,567"
			normalized = str.replace(/,/g, '')
		} else {
			const afterComma = str.slice(lastComma + 1)
			// Exactly 3 digits after single comma → thousands separator, e.g. "1,234"
			normalized = afterComma.length === 3
				? str.replace(',', '')
				: str.replace(',', '.')
		}
	} else if(lastDot !== -1) {
		if(dotCount > 1) {
			// Multiple dots → all are thousands separators, e.g. "1.234.567"
			normalized = str.replace(/\./g, '')
		} else {
			const afterDot = str.slice(lastDot + 1)
			// Exactly 3 digits after single dot → thousands separator, e.g. "1.234"
			normalized = afterDot.length === 3
				? str.replace('.', '')
				: str
		}
	} else {
		normalized = str
	}

	const num = parseFloat(normalized)
	return isNaN(num) ? null : num
}

export default parseImportPrice
